import styled, { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import flexStyle from './__buttons__/flexStyle';
import primaryStyle from './__buttons__/primaryStyle';
import secondaryStyle from './__buttons__/secondaryStyle';
import outlineStyle from './__buttons__/outlineStyle';
import disabledStyle from './__buttons__/disabledStyle';
import activeStyle from './__buttons__/activeStyle';
import jumboStyle from './__buttons__/jumboStyle';
import isColumnStyle from './__buttons__/isColumnStyle';
import radioStyle from './__buttons__/radioStyle';
import stretchStyle from './__buttons__/stretchStyle';
import smallStyle from './__buttons__/smallStyle';
import boldStyle from './__buttons__/boldStyle';
import inlineStyle from './__buttons__/inlineStyle';
import iconOnlyStyle from './__buttons__/iconOnlyStyle';
import customColourStyle from './__buttons__/customColourStyle';
import removeUnderlineStyle from './__buttons__/removeUnderlineStyle';
import inlineTableStyle from './__buttons__/inlineTableStyle';
import narrowStyle from './__buttons__/narrowStyle';
import maxWidthJumboIconStyle from './__buttons__/maxWidthJumboIconStyle';
import sharpEdgesStyle from './__buttons__/sharpEdgesStyle';
import blockStyle from './__buttons__/blockStyle';
import destructiveStyle from './__buttons__/destructiveStyle';
import loadingStyle from './__buttons__/loadingStyle';

import '/shared/fonts/BpSans/stylesheet.css';
import Colours from '/shared/styled/Colours';

function backgroundColorOverride({ $backgroundColour }: ButtonStyleProps) {
  if ($backgroundColour) {
    return css`
      background-color: ${$backgroundColour};
      border: 1px solid ${Colours.white};

      div {
        span {
          color: ${Colours.white};
        }
      }
    `;
  }
}

function fontColorOverride({ $fontColour }: ButtonStyleProps) {
  if ($fontColour) {
    return css`
      color: ${$fontColour} !important;
    `;
  }
}

function minWidthOverride({ $minWidth }: ButtonStyleProps) {
  if ($minWidth) {
    return css`
      min-width: ${$minWidth};
    `;
  }
}

export default styled.button<ButtonStyleProps>`
  display: inline-block;
  appearance: none;
  border: 0;
  cursor: pointer;
  transition:
    0.3s ease-in-out color,
    0.3s ease-in-out background-color,
    0.3s ease-in-out border-color,
    0.3s ease-in-out opacity,
    0.3s ease-in-out width;
  text-decoration: none;
  font-size: inherit;
  font-family: 'BpSans', sans-serif;
  line-height: 1;
  padding: 0;
  font-weight: inherit;
  background: transparent;
  color: inherit;
  -webkit-font-smoothing: antialiased;
  text-align: left;
  letter-spacing: 0.05px;

  small {
    display: block;
    margin-top: 0.25rem;
    line-height: 1.3;
    color: ${Colours.grey};
  }

  ${flexStyle}
  ${primaryStyle}
  ${secondaryStyle}
  ${outlineStyle}
  ${stretchStyle}
  ${iconOnlyStyle}
  ${smallStyle}
  ${jumboStyle}
  ${isColumnStyle}
  ${radioStyle}
  ${disabledStyle}
  ${activeStyle}
  ${boldStyle}
  ${inlineStyle}
  ${customColourStyle}
  ${removeUnderlineStyle}
  ${inlineTableStyle}
  ${narrowStyle}
  ${maxWidthJumboIconStyle}
  ${sharpEdgesStyle}
  ${blockStyle}
  ${destructiveStyle}
  ${backgroundColorOverride}
  ${fontColorOverride}
  ${minWidthOverride}
  ${loadingStyle}
`;
